import axios from 'axios';
import { CLIENT_ID } from '../../helperData/Constatns';

export const configRequest = (method, requestUrl, auth, data, language) => {
    const authen = window.sessionStorage.auth;
    
	return {
		method: method,
		url: requestUrl,
		headers: {
			Authorization: `Bearer ${authen}`,
            "Accept-Language": language || "*"
		},
		data: data !== undefined && {...data, client_id: CLIENT_ID},
		proxy: false
	};
};

/*let auth = {
    'access_token': 'PdLEik99HJ9LR8RAh6T1aRnShonSSo',
};

export const setAuth = (newAuth) => {
    auth = newAuth;
};*/

const isAuthFreeRequest = (url) =>
    typeof url === "string" && url.includes("/o/token");

export const request = (url, method, params, data) => {
    const auth = window.sessionStorage.auth;

    if (url.toString().indexOf("?") < 0 && url[url.length - 1] !== "/") {
        url = url + "/";
    }

    const headers = {};
    if (auth && !isAuthFreeRequest(url)) {
        headers.Authorization = `Bearer ${auth}`;
    }

    return axios({
        url,
        method,
        data: { ...data, client_id: CLIENT_ID },
        params,
        headers,
    })
        .then(response => {
            let data = response.data;
            if (data.hasOwnProperty('data')) {
                data = data.data;
            }
            return data;
        })
        .catch(error => {
            console.log(error);
            // return(error.response.data)
            // TODO handle errors
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            throw error;
        });
};

export const get = (url, params = {}) => {
    return request(url, 'get', params);
};

export const post = (url, data = {}) => {
    return request(url, 'post', undefined, data);
};

export const patch = (url, data = {}) => {
    return request(url, 'patch', undefined, data);
};

export const del = (url, data = {}) => {
    return request(url, 'delete', undefined, data);
};

export const put = (url, data = {}) => {
    return request(url, 'put', undefined, data);
};
